import { ActionTypes } from '../../constants/action-types';
import { SegmentCancelAction, SegmentSelectAction } from './types';

export function selectSegment(id: string): SegmentSelectAction {
  return { type: ActionTypes.SEGMENT_SELECT, id };
}

// This is called by clicking on the UI which requires us to go back one history state
export function cancelSegment(): SegmentCancelAction {
  history.back();
  return cancelSegmentFromBackButton();
}

// We've already popped a state via the back button so don't bother go back
export function cancelSegmentFromBackButton(): SegmentCancelAction {
  window.onpopstate = null;
  return { type: ActionTypes.SEGMENT_DESELECT };
}
